// src/i18n.js
import { createI18n } from 'vue-i18n';
import en from './locales/en.json';
import zhHans from './locales/zh-Hans.json';

const messages = {
    en: en,
    'zh-Hans': zhHans
};

const i18n = createI18n({
    locale: 'en', // 默认语言
    fallbackLocale: 'zh-Hans', // 备用语言
    messages
});

export default i18n;
